export default __webpack_public_path__ + "static/media/Safeguardingv9SafeguardingprocedureV9(4)_flowchart.2cbac7ea.jpg";